import {
  PaymentDetails,
  PaymentSubmissionOutcome,
} from '@generated/gql/graphql.ts';

import { SpreedlyResponse } from './types';

export const getHandleSpreedlyResponse =
  (
    submitDeposit: (
      basketId: string,
      paymentDetails: PaymentDetails
    ) => Promise<PaymentSubmissionOutcome>,
    basketId: string,
    isMobile: boolean
  ) =>
  (response: unknown) => {
    const typedResponse = response as SpreedlyResponse;
    // Choose a browser size for your application. This will be the size of the challenge
    // iframe that will be presented to a user. *note* If you're creating a modal, you
    // should make the surrounding DOM node a little larger than the option selected
    // below.
    //
    // '01' - 250px x 400px
    // '02' - 390px x 300px
    // '03' - 500px x 600px
    // '04' - 600px x 400px
    // '05' - fullscreen
    // TODO: Adjust size for smaller screens (maybe just mobile devices)
    const browser_size = isMobile ? '02' : '04';
    // The accept header from your server side rendered page. You'll need to inject it into the page. Below is an example.
    const acceptHeader =
      'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8';
    // The request should include the browser data collected by using `Spreedly.ThreeDS.serialize().
    const browser_info = window.Spreedly.ThreeDS.serialize(
      browser_size,
      acceptHeader
    );

    const paymentDetails = {
      browserFingerprint: browser_info,
      token: typedResponse.token,
      redirectURL: window.location.href,
    };

    submitDeposit(basketId, paymentDetails)
      .then((response) => {
        // console.log({ response });
        return response;
      })
      .catch(() => {
        // console.log({ Error });
      });
  };
